/* tslint:disable */
/* eslint-disable */
export enum WorkDocumentProcessingStatusEnum {
  New = 'NEW',
  Pending = 'PENDING',
  Done = 'DONE',
  Failed = 'FAILED',
  Skipped = 'SKIPPED',
  Proposal = 'PROPOSAL'
}
